import React, { useEffect, useState } from 'react';
import Layout from '../../Layout';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Flex,
  Form,
  Progress,
  Space,
  Steps
} from 'antd';
import './PoolingDataAutoDetail.scss'
import Select from './ComponentPoolingData/Select';
import SelectSystem from './ComponentPoolingData/SelectSystem';
import DragDropTitle from './ComponentPoolingData/DragDropTitle';
import { Link, useNavigate } from 'react-router-dom';
import { CloseCircleOutlined, DeleteFilled, DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { mixPostV2, mixGetV2, mixDate } from '../../services/mixin'
import useToast from '../../hook/useToast';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';

const PoolingDataMapping: React.FC = () => {
  const iconDrag = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 4.5C7 4.89782 7.15804 5.27936 7.43934 5.56066C7.72064 5.84196 8.10218 6 8.5 6C8.89782 6 9.27936 5.84196 9.56066 5.56066C9.84197 5.27936 10 4.89782 10 4.5C10 4.10218 9.84197 3.72064 9.56066 3.43934C9.27936 3.15804 8.89782 3 8.5 3C8.10218 3 7.72064 3.15804 7.43934 3.43934C7.15804 3.72064 7 4.10218 7 4.5Z" fill="#98A2B3"/><path d="M14 4.5C14 4.89782 14.158 5.27936 14.4393 5.56066C14.7206 5.84196 15.1022 6 15.5 6C15.8978 6 16.2794 5.84196 16.5607 5.56066C16.842 5.27936 17 4.89782 17 4.5C17 4.10218 16.842 3.72064 16.5607 3.43934C16.2794 3.15804 15.8978 3 15.5 3C15.1022 3 14.7206 3.15804 14.4393 3.43934C14.158 3.72064 14 4.10218 14 4.5Z" fill="#98A2B3"/><path d="M7 12C7 12.3978 7.15804 12.7794 7.43934 13.0607C7.72064 13.342 8.10218 13.5 8.5 13.5C8.89782 13.5 9.27936 13.342 9.56066 13.0607C9.84197 12.7794 10 12.3978 10 12C10 11.6022 9.84197 11.2206 9.56066 10.9393C9.27936 10.658 8.89782 10.5 8.5 10.5C8.10218 10.5 7.72064 10.658 7.43934 10.9393C7.15804 11.2206 7 11.6022 7 12Z" fill="#98A2B3"/><path d="M14 12C14 12.3978 14.158 12.7794 14.4393 13.0607C14.7206 13.342 15.1022 13.5 15.5 13.5C15.8978 13.5 16.2794 13.342 16.5607 13.0607C16.842 12.7794 17 12.3978 17 12C17 11.6022 16.842 11.2206 16.5607 10.9393C16.2794 10.658 15.8978 10.5 15.5 10.5C15.1022 10.5 14.7206 10.658 14.4393 10.9393C14.158 11.2206 14 11.6022 14 12Z" fill="#98A2B3"/><path d="M7 19.5C7 19.8978 7.15804 20.2794 7.43934 20.5607C7.72064 20.842 8.10218 21 8.5 21C8.89782 21 9.27936 20.842 9.56066 20.5607C9.84197 20.2794 10 19.8978 10 19.5C10 19.1022 9.84197 18.7206 9.56066 18.4393C9.27936 18.158 8.89782 18 8.5 18C8.10218 18 7.72064 18.158 7.43934 18.4393C7.15804 18.7206 7 19.1022 7 19.5Z" fill="#98A2B3"/><path d="M14 19.5C14 19.8978 14.158 20.2794 14.4393 20.5607C14.7206 20.842 15.1022 21 15.5 21C15.8978 21 16.2794 20.842 16.5607 20.5607C16.842 20.2794 17 19.8978 17 19.5C17 19.1022 16.842 18.7206 16.5607 18.4393C16.2794 18.158 15.8978 18 15.5 18C15.1022 18 14.7206 18.158 14.4393 18.4393C14.158 18.7206 14 19.1022 14 19.5Z" fill="#98A2B3"/>`

  const navigate = useNavigate()
  const pushToast = useToast();
  const [opSelectSystem, setOpSelectSystem] = useState(false);
  const [showSelectFilterAddSeclect, setActiveAddSelect] = useState(false);
  const [isShowValue, setShowValue] = useState('Chọn giá trị')

  const handleClearFilter = (e: any) => {
    setActiveAddSelect(false)
    setShowValue(e)
  }

  const [isStep, setStep] = useState(1);
  const [cusCount, setCusCount] = useState(0)
  let wait1 = false
  const setActiveStep2 = async () => {
    if (wait1) {
      return
    }
    wait1 = true

    if (Object.keys(checkx).length === 0) {
      pushToast("Chưa chọn dữ liệu!", "error")
      return
    }
    setStep(2)
    const data = {} as any
    const ids = [] as any
    Object.keys(checkx).map((iskey: any) => {
      const arr = iskey.split('_id_')
      data[arr[0]] = checkx[iskey]
      if (ids.includes(arr[1]) === false) {
        ids.push(arr[1])
      }
      return true
    })
    const res = await mixPostV2('/api/v1/be/merge_warehouse', {
      data: JSON.stringify(data),
      data_migration_id: sessionStorage.getItem('idMigration')
    })
    if (res.status) {
      setCusCount(ids.length)
      setStep(3)
    } else {
      pushToast("Error!", "error")
      setStep(1)
    }
    wait1 = false

    // setStep(2)
    // setTimeout(() => {
    //   setStep(3);
    // }, 3000);
  }

  // Get list data
  const [listData, setListData] = useState([] as any)
  const [colMix, setColMix] = useState([] as any)
  const [colMap, setColMap] = useState({} as any)
  const [keyCheck, setKeyCheck] = useState({} as any)
  const [keyHl, setKeyHl] = useState({} as any)
  let wait3 = false
  const getListData = async () => {
    if (wait3) {
      return
    }
    wait3 = true

    const res0 = await mixGetV2('/api/v1/be/column_warehouses', {
      'sort[]': 'id,asc',
      page: 1,
      limit: 100000,
      name: '',
      type_id: 1,
    })
    const res2 = await mixGetV2('/api/v1/be/setting_mapping', { type: 1 })
    let column = {} as any
    const tempCol = [] as any
    if (res2.status) {
      const temp = JSON.parse(res2.data.value || '{}')
      setColMap({ ...temp.obSourceColMap })
      column = { ...temp.column }
      // temp.column.map((val: any) => {
      //   obTemp[`id${val.source_column_warehouses_id}`] = val
      //   return true
      // })
    }
    if (res0.status) {
      res0.data.items.map((val: any) => {
        tempCol.push({
          id: val.id.toString(),
          name: val.name,
          field: val.column,
          status: false,
          position: column[val.column] || res0.data.items.length + 1,
          checkdata: '',
        })
        return true
      })
      tempCol.sort((a: any, b: any) => {
        return a.position - b.position
      })
    }

    const res = await mixPostV2('/api/v1/be/detail_duplicate?sort[]=id,desc', {
      data: sessionStorage.getItem('itemDup')
    })
    wait3 = false
    if (res.status) {
      const templistData = res.data.items || [];
      const keyCheckx = {} as any;
      const defcheck = {} as any;
      const hlx = {} as any;
      tempCol.map((val: any, index: any) => {
        let cx = 0
        keyCheckx[val.field] = ''
        const hasValIndex = [] as any
        const valList = [] as any
        templistData.map((val2: any, index2: any) => {
          if (val2[val.field]) {
            cx += 1
            if (valList.includes(val2[val.field]) === false) {
              valList.push(val2[val.field])
              hlx[`${val.field}${index2}`] = true
            }
            hasValIndex.push(index2)
          }
          return true
        })
        if(cx === 0) {
          keyCheckx[val.field] = 'keyCheck-emty'
        }
        if (cx === 1) {
          keyCheckx[val.field] = 'keyCheck-one'
          defcheck[`${val.field}_id_${templistData[hasValIndex[0]].warehouse_id_origin}`] = templistData[hasValIndex[0]][val.field]
        }
        if (cx > 1) {
          keyCheckx[val.field] = 'keyCheck-many'
          if (valList.length === 1) {
            keyCheckx[val.field] = 'keyCheck-samedata'
            defcheck[`${val.field}_id_${templistData[hasValIndex[0]].warehouse_id_origin}`] = templistData[hasValIndex[0]][val.field]
          }
        }
        return true
      })
      setKeyHl(hlx)
      setCheckx(defcheck)
      setKeyCheck(keyCheckx)
      setListData(templistData)
    }
    setColMix(tempCol)
  }
  useEffect(() => {
    getListData()
  }, [])

  const [checkx, setCheckx] = useState({} as any)

  const changeF = (st: any, filed: any, val: any, id: any) => {
    const temp = {} as any
    temp[`${filed}_id_${id}`] = val
    if (st) {
      listData.map((val: any) => {
        if (val.warehouse_id_origin !== id) {
          delete checkx[`${filed}_id_${val.warehouse_id_origin}`]
        }
        return true
      })
      setCheckx({ ...checkx, ...temp })
    } else {
      const newob = { ...checkx } as any
      delete newob[`${filed}_id_${id}`]
      setCheckx(newob)
    }
  }

  const backList = () => {
    navigate('/customer/pooling-data/pooling-data-auto')
  }
  return (
    <div className='pooling-data-detail-page'>
      <Layout>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Khách hàng', },
            { title: <Link to="/customer/pooling-data">Gộp dữ liệu khách hàng</Link>, },
            { title: 'Xác nhận dữ liệu gộp', },
          ]}
          title='Xác nhận dữ liệu gộp'
          backLink='/customer/pooling-data'
          className='gutter-block-end'
        />

        {isStep === 1 && (
          <div className="pooling-data-auto-detail-content">
            <div className="title-page-cl-fabc16">
              <ExclamationCircleOutlined />
              <div className="text">Dữ liệu bản ghi chính sẽ được giữ lại. Các dữ liệu của bản ghi phụ sẽ bị xóa và các dữ liệu liên quan của bản ghi phụ sẽ giao cho bản ghi chính.</div>
            </div>

            <div className="list-mapping">
              <div className="one-item">
                <div className="h-44 mb-24"></div>
                <div className="title h-44">Biến trên CRM</div>
                <div className="drag-drop-content" >
                  {
                    colMix.map((item: any) => (
                      <li
                        className={`one-op h-44 ${keyCheck[item.field]}`}
                        key={item.id}
                      >
                        <div className="text">
                          {item.name}
                        </div>
                      </li>
                    ))
                  }
                </div>
              </div>

              <div className="list-add-mapping">
                <div className="form-add-select">
                  {listData.map((val: any, index0: any) => (
                    <div className="one-data-auto" key={val.warehouse_id_origin}>
                      <div className="h-44 mb-24 d-flex align-center username-system">
                        {val.fullname} (#Customer{val.warehouse_id_origin})
                        <Button
                          size="small"
                          style={{ marginLeft: 8 }}
                          onClick={() => {
                            // Chọn tất cả giá trị của bản ghi này
                            const newCheckx = {...checkx} as any;
                            colMix.forEach((col: any) => {
                              const value = val[col.field];
                              if (value) {
                                newCheckx[`${col.field}_id_${val.warehouse_id_origin}`] = value;
                                listData.map((valx: any) => {
                                  if (valx.warehouse_id_origin !== val.warehouse_id_origin) {
                                    delete newCheckx[`${col.field}_id_${valx.warehouse_id_origin}`]
                                  }
                                  return true
                                })
                              }
                            });
                            setCheckx(newCheckx);
                          }}
                        >
                          Chọn tất cả
                        </Button>
                      </div>
                      <div className="h-44 title-add">
                        <div className="text">Thông tin cá nhân (Ngày tạo: {mixDate(val.created_at)})</div>
                      </div>

                      {colMix.map((val2: any) => {
                        const value = val[val2.field];
                        const key = `${val2.field}_id_${val.warehouse_id_origin}`;
                        const isChecked = checkx[key] === value;
                        const isDisabled = !value;

                        return (
                          <Checkbox
                            key={val2.id}
                            className={`one-add-filter-content v2 h-44 d-flex align-center ${keyCheck[val2.field]} ${keyHl[`${val2.field}${index0}`] ? 'keyHl' : ''}`}
                            onChange={(e) => {
                              if (!isDisabled) {
                                changeF(e.target.checked, val2.field, value, val.warehouse_id_origin);
                              }
                            }}
                            checked={!isDisabled && isChecked}
                            disabled={isDisabled}
                          >
                            <div className="text" title={value}>{value || ''}</div>
                          </Checkbox>
                        );
                      })}

                      {/* <Checkbox className="one-add-filter-content h-44 d-flex align-center" value="2">
                        <div className="text">039222345</div>
                      </Checkbox>
                      <Checkbox className="one-add-filter-content h-44 d-flex align-center" value="3">
                        <div className="text">Chưa cập nhật</div>
                      </Checkbox>
                      <Checkbox className="one-add-filter-content h-44 d-flex align-center" value="4">
                        <div className="text">06/06/1990</div>
                      </Checkbox>
                      <Checkbox className="one-add-filter-content h-44 d-flex align-center" value="5">
                        <div className="text">phong.nguyen@bluebolt.consulting</div>
                      </Checkbox>
                      <Checkbox className="one-add-filter-content h-44 d-flex align-center" value="6">
                        <div className="text">BA</div>
                      </Checkbox>
                      <Checkbox className="one-add-filter-content h-44 d-flex align-center" value="7">
                        <div className="text">245E/1 Hoàng Văn Thụ, Tân Bình, TPHCM</div>
                      </Checkbox>
                      <Checkbox className="one-add-filter-content h-44 d-flex align-center" value="8">
                        <div className="list-system">
                          <div className="one-system">DDMS</div>
                          <div className="one-system">IPCC</div>
                          <div className="one-system">SALESFORCE</div>
                        </div>
                      </Checkbox> */}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="btn-block">
              <Link to="/customer/pooling-data/pooling-data-auto" className="btn-black btn">Quay lại</Link>
              <div className="bg-F2F4F7">
                <div onClick={setActiveStep2} className="btn-black btn btn-primary">Gộp dữ liệu</div>
              </div>
            </div>
          </div>
        )}
        {isStep === 2 && (
          <div className="load-check-data mw-395">
            <div className="img-box">
              <img src="/images/logo-gif.png" alt="img check load" />
            </div>
            <div className="percent-block">
              <div className="label">Đang gộp dữ liệu</div>
              <div className="load-percent">
                <div className="line-load">
                  <div
                    className="percent"
                    style={{
                      width: '40%',
                    }}
                  />
                </div>
                <div className="count-percent">40%</div>
              </div>
            </div>
            <div className="des">
              <div className="icon">
                <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7.5 10.375C7.5 10.4438 7.44375 10.5 7.375 10.5H6.625C6.55625 10.5 6.5 10.4438 6.5 10.375V6.125C6.5 6.05625 6.55625 6 6.625 6H7.375C7.44375 6 7.5 6.05625 7.5 6.125V10.375ZM7 5C6.80374 4.99599 6.61687 4.91522 6.47948 4.775C6.3421 4.63478 6.26515 4.4463 6.26515 4.25C6.26515 4.0537 6.3421 3.86522 6.47948 3.725C6.61687 3.58478 6.80374 3.50401 7 3.5C7.19626 3.50401 7.38313 3.58478 7.52052 3.725C7.6579 3.86522 7.73485 4.0537 7.73485 4.25C7.73485 4.4463 7.6579 4.63478 7.52052 4.775C7.38313 4.91522 7.19626 4.99599 7 5Z" fill="#1890FF" /></svg>
              </div>
              <div className="text">Hệ thống đang xử lý dữ liệu gộp.Tiến trình này có thể mất nhiều thời gian tùy thuộc vào số lượng bản ghi được gộp Vui lòng không thoát khỏi hệ thống cho đến khi tiến trình hoàn thành</div>
            </div>
          </div>
        )}

        {isStep === 3 && (
          <div className='step3-pooling-data'>
            <div className="load-data-pooling-data message-pooling-success">
              <div className="img-box">
                <img src="/images/pooling-success.svg" alt="success" />
              </div>
              <div className="title-block">
                <div className="title">Thành công</div>
                <div className="text">Đã gộp thành công <span className='cl-096DD9'>{cusCount}</span> khách hàng và lưu dữ liệu vào danh sách khách hàng</div>
              </div>
            </div>
            <div className="btn-pooling-data-block">
              <div className="ctrl-btn-pooling-data ctrl-2btn">
                <div className="btn" onClick={() => backList()}>Gộp thêm dữ liệu khác</div>
              </div>
            </div>
          </div>
        )}

      </Layout>
    </div>
  );
}

export default PoolingDataMapping;
